import { useState } from 'react';
import BrokenMedia from './BrokenMedia';

const SafeImg = ({ className = '', style, src, alt, onClick, onLoad, onError: onErrorCallback }) => {
  const [error, setError] = useState(false);

  if (error) return <BrokenMedia className={`w-100 h-100 ${className}`} />;

  return (
    <img
      className={className}
      style={style}
      src={src}
      alt={alt}
      onClick={onClick}
      onLoad={onLoad}
      onError={() => { setError(true); onErrorCallback?.(); }}
    />
  );
};

export default SafeImg;
